module.exports = __webpack_public_path__ + "img/php.a18963d2.png";